import dateFormat from "dateformat";

export function date(value, mask) {
	const v = isNaN(value) ? value : Number(value)
	const dateValue = new Date(v)
	const maskToUse = mask ? mask : "dd/mm/yyyy";

	return dateValue.getTime() ? dateFormat(dateValue, maskToUse) : null;
}